import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GridApi, GridOptions, GridReadyEvent } from 'ag-grid';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { ReservationNoteService } from '../reservation-note.service';
import { Subscription} from 'rxjs/Subscription';
import { NoteTemplateService } from 'app/core/services/note-template.service';
import { finalize } from 'rxjs/operators';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ComplaintStatusEnum } from 'app/core/enums/complaint-status.enum';

@Component({
  selector: 'app-reservation-note-list',
  templateUrl: './reservation-note-list.component.html',
  styleUrls: ['./reservation-note-list.component.scss']
})
export class ReservationNoteListComponent implements OnInit, OnChanges, OnDestroy {
  protected grid: GridOptions;
  protected newOption = 0;
  protected noteid: number;
  protected standingordernoteid: number;
  protected notetype: string;
  private observables: Subscription[] = [];
  count = 0;

  @Input() tripid?: number;
  @Input() riderid?: number;
  @Input() providerid: number;
  @Input() standingOrderId?: number;
  @Input() soId?: number;
  @Input() actionDeleteNote: boolean;
  @Input() actionEditNote: boolean;

  @ViewChild('newnote') newBtn: ElementRef;
  @ViewChild('modalNote') ModalNote: T2CardComponent;
  @ViewChild('noteListModal') noteListModal: T2CardComponent;
  gridOptions: GridOptions;

  constructor(
    protected service: ReservationNoteService,
    private sweetAlertHelper: SweetAlertHelper,
    protected objNoteTemplateServ: NoteTemplateService,
    private loadingService: T2LoadingService
    ) {
    this.grid = < GridOptions > {};
    this.configureGrid();
    this.noteTemplateGrid();
  }

  ngOnInit(): void {
    this.initObservables();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['tripid']) {
      this.getTripNotes(this.tripid);
    }
    if (changes['standingOrderId']) {
      if (this.standingOrderId) {
        this.getSONotes();
      }
    }
  }

  initObservables(): void {
    this.observables.push(
      this.service.noteTemplateSubject$.subscribe({
        next: (res) => {
          if (res && res.openModal && res.rowData === null) {
            this.noteListModal.open();
          }
        }
      }),
      this.objNoteTemplateServ.getTemplateNote()
      .subscribe({
        next: (data: any) => {
          if (data && data.length) {
            this.count = data.length;
            this.gridOptions.api.setRowData(data);
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  /**
   * @description
   */
  private configureGrid() {
    const self = this;
    this.grid.columnDefs = [{
      headerName: '',
      width: 50,
      checkboxSelection: true

    },
      {
        headerName: 'Date',
        field: 'note.date',
        colId: 'date',
        width: 120,
      },
      {
        headerName: 'Time',
        field: 'note.time',
        colId: 'consecutive',
        width: 100
      },
      {
        headerName: 'Note',
        field: 'note.description',
        colId: 'note',
        width: 330,
        cellStyle: {
          'white-space': 'normal'
        }
      },
      {
        headerName: 'User',
        field: 'note.adminuser.fullname',
        colId: 'status',
        width: 120
      },
      {
        headerName: 'Type',
        field: 'note.noteregistertype.value',
        colId: 'status',
        width: 100
      }
    ];

    this.grid.getRowHeight = function (params) {
      return 25 * (Math.floor(params.data.note.description.length / 45) + 1);
    };

    this.grid.onGridReady = function () {
      self.grid.api.sizeColumnsToFit();
      // self.getTripNotes(self.tripid); esto se estaba llamando dos veces mas de las necesarias...
    };

    this.grid.getRowStyle = this.getRowStyle;
    this.grid.defaultColDef = {
      tooltip: (params) => {
        return params.data && params.data.note && params.data.note.notestatus && params.data.note.notestatus.value !== ''
          ? params.data.note.notestatus.value
          : 'no status';
      }
    };
  }

  noteTemplateGrid(): void {
    this.gridOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple',
      columnDefs: [
        {
          colId: 'notetemplateid',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 30,
          hide: true
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 500
        },
        {
          headerName: 'Speed Code',
          field: 'speedcode',
          width: 150
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event) {
          this.gridOptions.api.setRowData([]);
          this.gridOptions.api.sizeColumnsToFit();
        }
      },
      onRowDoubleClicked: (row): void => {
        this.setterNoteTemplate(row);
      }
    };
  }

  /**
   * @description
   * @param event
   */
  public onRowDoubleClickedTrip(event) {
      this.standingordernoteid = event.data.standingordernoteid;
      this.noteid = event.data.tripnoteid;
      this.notetype = event.data.note.noteregistertype.value;
      this.newOption = 2;
      this.ModalNote.open();
  }

  /**
   * @description
   */
  public newNoteForm() {
    this.newOption = 1;
    this.ModalNote.open();
    this.service.noteTermplateSendData(null);
  }

  /**
   * @description
   */
  public closeAfterSave() {
    // this.ModalNote.close();
    if (this.standingOrderId) {
      this.getSONotes();
    } else {
      this.getTripNotes(this.tripid);
    }
    this.ModalNote.close();
    this.newOption = 0;
  }

  public closeNoteForm(event) {
    // this.ModalNote.close();
    if (!event.isOpen) {
      this.newOption = 0;
    }
  }

  /**
   * @description
   */
  public deleteNote() {
    if (this.grid.api.getSelectedNodes().length > 0) {
      this.loadingService.show();
      const data = this.grid.api.getSelectedNodes();
      const type = data[0].data.note.noteregistertype.value;
      const id = (data[0].data.note.noteid);
      if (this.standingOrderId || type === 'Standing Order') {
        this.observables.push(
          this.service.deleteStandingNote(id)
            .pipe(finalize(() => this.loadingService.hiden()))
            .subscribe(() => {
            this.sweetAlertHelper.createCustomAlert({
              text: 'Standing Order Note deleted successfully',
              type: 'info',
              confirmButtonText: 'Ok'
            }).then(() => {
              this.getSONotes();
              this.getTripNotes(this.tripid);
            });
          }, error => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error!',
              text: error.message,
              type: 'error'
            });
          }));
      } else {
        this.observables.push(
          this.service.deleteTripNote(id)
            .pipe(finalize(() => this.loadingService.hiden()))
            .subscribe(() => {
            this.sweetAlertHelper.createCustomAlert({
              text: 'Trip Note deleted successfully',
              type: 'info',
              confirmButtonText: 'Ok'
            }).then(() => {
              this.getTripNotes(this.tripid);
              this.getSONotes();
            });
          }, error => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error!',
              text: error.message,
              type: 'error',
            });
          }));
      }
    }
  }

  /**@description
   * @param id
   */
  public getTripNotes(id) {
    if (id !== 0 && (typeof (id) === 'number')) {
      this.observables.push(
        this.service.getTripNotes(id).subscribe(
          data => {
            if (this.grid) {
              if (this.grid.api) {
                this.grid.api.setRowData(data);
              }
            }
          }));
    }
  }

  getSONotes() {
    const soId = this.standingOrderId ? this.standingOrderId : this.soId;
    if (soId) {
      this.observables.push(
      this.service.getStandingNotes(soId).subscribe(
        data => {
          if (this.grid) {
            if (this.grid.api) {
              this.grid.api.setRowData(data);
            }
          }
        }
      ));
    }
  }

  reloadData() {
    if (this.standingOrderId) {
      this.getSONotes();
    } else {
      this.getTripNotes(this.tripid);
    }
  }

  getRowStyle(params: any): any {
    if (params.data && params.data.note && params.data.note.notestatusid === ComplaintStatusEnum.Resolved) {
      return {
        'background-color': '#9f9'
      };
    }
  }

  setterNoteTemplate(row: any): void {
    if (row && row.data) {
      this.service.noteTermplateSendData({ openModal: true, rowData: row.data });
    }

    this.noteListModal.close();
  }

  get disableDeleteBtn(): boolean {
    const apiGrid: GridApi = this.grid.api;
    return !apiGrid || !apiGrid.getSelectedNodes().length;
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservation-notes/reservation-note-list/reservation-note-list.component.ts